import React from 'react'
import ReactDOM from 'react-dom/client'
import {RouterProvider} from 'react-router-dom'
import {router} from './helpers/navigation.router'
import {I18nextProvider} from 'react-i18next'
import i18n from './i18n'
import {ThemeProvider} from '@mui/material/styles'
import {theme} from './theme'
import {amplitudeService} from './service/amplitude.services'

import './index.css'

// Vite fires `vite:preloadError` when a lazy chunk fails to load — typically a
// tab left open across a deploy requesting an asset hash the server has purged.
// Reload once to pull the fresh index.html; the sessionStorage guard prevents a
// reload loop if the asset is genuinely missing.
const PRELOAD_RELOAD_FLAG = 'vite-preload-reloaded'
window.addEventListener('vite:preloadError', event => {
  event.preventDefault()
  if (!sessionStorage.getItem(PRELOAD_RELOAD_FLAG)) {
    sessionStorage.setItem(PRELOAD_RELOAD_FLAG, '1')
    window.location.reload()
  }
})
window.addEventListener('load', () =>
  sessionStorage.removeItem(PRELOAD_RELOAD_FLAG),
)

// Amplitude init
const amplitudeApiKey =
  window.__CONFIG__?.AMPLITUDE_API_KEY ?? import.meta.env.VITE_AMPLITUDE_API_KEY
// TODO: need to get env api key
if (amplitudeApiKey) {
  amplitudeService.init(amplitudeApiKey)
} else {
  console.warn('Amplitude API key not found in environment variables')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
